import gsap from 'gsap'
import { q1O } from '../util/nE'

class Cursor {
  constructor () {
    this.el = document.querySelector('.cursor')
  }

  init () {
    this.bindEvent()
  }

  bindEvent () {
    window.addEventListener('mousemove', this.onMouseMove.bind(this))

    document.querySelectorAll('[data-cursor]').forEach((el) => {
      el.addEventListener('mouseenter', (e) => this.onMouseEnter(e, el))
      el.addEventListener('mouseleave', () => this.onMouseLeave())
    })

    document.querySelectorAll('[data-cursor-hide]').forEach((el) => {
      el.addEventListener('mouseenter', () => this.onCursorHide())
      el.addEventListener('mouseleave', (e) => this.onCursorShow(el))
    })
  }

  onMouseEnter (e, el) {
    gsap.to(this.el, {
      autoAlpha: 1,
      scale: 1,
      ease: (t) => {
        return q1O(t)
      },
      duration: 1.3,
      overwrite: true,
    })

    const text = el.getAttribute('data-cursor-text') || ''
    const bg = el.getAttribute('data-cursor-bg') || '#005df8'
    const color = el.getAttribute('data-cursor-color') || '#f9f9f4'

    this.el.innerText = text
    this.el.style.backgroundColor = bg
    this.el.style.color = color

    this.lastActiveCursorSection = el
  }

  onMouseLeave () {
    gsap.to(this.el, {
      autoAlpha: 0,
      scale: 0,
      ease: (t) => {
        return q1O(t)
      },
      duration: 0.7,
      overwrite: true,
    })

    this.lastActiveCursorSection = null
  }

  onMouseMove (e) {
    const xTo = gsap.quickTo(this.el, 'x', {
      duration: 0.7,
      ease: (t) => {
        return q1O(t)
      },
    })
    const yTo = gsap.quickTo(this.el, 'y', {
      duration: 0.7,
      ease: (t) => {
        return q1O(t)
      },
    })

    xTo(e.clientX)
    yTo(e.clientY)
  }

  onCursorHide () {
    gsap.to(this.el, {
      autoAlpha: 0,
      scale: 0,
      ease: (t) => {
        return q1O(t)
      },
      duration: 0.7,
      overwrite: true,
    })
  }

  onCursorShow (el) {
    // Check if the element is inside a `data-cursor` section
    const parentCursorSection = el.closest('[data-cursor]')

    if (parentCursorSection && this.lastActiveCursorSection === parentCursorSection) {
      gsap.to(this.el, {
        autoAlpha: 1,
        scale: 1,
        ease: (t) => {
          return q1O(t)
        },
        duration: 1.3,
        overwrite: true,
      })
    }
  }

  destroy () {

  }
}

export default Cursor



//////////////////
// WEBPACK FOOTER
// ./scripts/components/Cursor.js
// module id = 76
// module chunks = 0